var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4688 0.734375C10.6562 0.875 10.7031 1.0625 10.7031 1.25C10.7031 1.4375 10.6562 1.625 10.5156 1.76562L1.98438 11L10.4688 20.2812C10.75 20.5625 10.75 21.0312 10.4219 21.3125C10.1406 21.5938 9.67188 21.5938 9.39062 21.2656L0.390625 11.5156C0.109375 11.2344 0.109375 10.8125 0.390625 10.5312L9.39062 0.78125C9.71875 0.453125 10.1875 0.453125 10.4688 0.734375Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.23b270835fa6e9a934a5c01adfd7eec4.svg";
export { ForwardRef as ReactComponent };